/* eslint-disable @typescript-eslint/no-unused-vars */
import { Navigate, useLocation } from "react-router-dom";
import { useWebChat } from "../context/webChatContext";

const PublicRoute = ({ children }: any) => {
  const { pathname } = useLocation();

  const { isAuthenticated } = useWebChat();

  if (isAuthenticated === null) {
    return;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PublicRoute;
